import { createSelector } from 'reselect';
 
const selectChapterResponses = (state: any) => state.chapterResponses;
 
export const selectChapterResponsesCurrentItem = createSelector([selectChapterResponses], (chapterResponses) => chapterResponses.current);
 
export const selectChapterResponsesListItems = createSelector([selectChapterResponses], (chapterResponses) => chapterResponses.list);
 
 
export const selectChapterResponsesItemById = (itemId: any) =>
    createSelector(selectChapterResponsesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));
 
export const selectChapterResponsesQueryItems = createSelector([selectChapterResponses], (chapterResponses) => chapterResponses.query);

export const selectChapterResponsesCreatedItem = createSelector([selectChapterResponses], (chapterResponses) => chapterResponses.create);
 
export const selectChapterResponsesUpdatedItem = createSelector([selectChapterResponses], (chapterResponses) => chapterResponses.update);
 
export const selectChapterResponsesReadItem = createSelector([selectChapterResponses], (chapterResponses) => chapterResponses.read);
 
export const selectChapterResponsesDeletedItem = createSelector([selectChapterResponses], (chapterResponses) => chapterResponses.delete);
 
export const selectChapterResponsesSearchedItems = createSelector([selectChapterResponses], (chapterResponses) => chapterResponses.search);
 
export const selectChapterResponsesItemsCount = createSelector([selectChapterResponses], (chapterResponses) => chapterResponses.count);
 
export const selectChapterResponsesItemsFilter = createSelector([selectChapterResponses], (chapterResponses) => chapterResponses.filter);